import { createAsyncAction } from 'store/actionConfigs';
import type { PageParams } from 'types/api';
import type {
  CustomerDetail,
  CustomerList,
  CustomerSummary,
  CustomerTransaction,
} from 'types/models';
import { PREFIX_ACTIONS } from './constants';
const getAllCustomers = createAsyncAction<Partial<PageParams>, CustomerList>(PREFIX_ACTIONS + 'getAllCustomers');
const getSummaryCustomers = createAsyncAction<void, CustomerSummary>(PREFIX_ACTIONS + 'getSummaryCustomers');
const getCustomersByGroup = createAsyncAction<Partial<PageParams>, CustomerList>(PREFIX_ACTIONS + 'getCustomersByGroup');
const getSummaryCustomersByGroup = createAsyncAction<string, CustomerSummary>(PREFIX_ACTIONS + 'getSummaryCustomersByGroup');
const getCustomerDetail = createAsyncAction<number | string, CustomerDetail>(PREFIX_ACTIONS + 'getCustomerDetail');
const getCustomerTransactions = createAsyncAction<number | string, CustomerTransaction[]>(PREFIX_ACTIONS + 'getCustomerTransactions');

const customerActions = {
  getAllCustomers,
  getSummaryCustomers,
  getCustomersByGroup,
  getCustomerDetail,
  getCustomerTransactions,
  getSummaryCustomersByGroup,
};

export default customerActions;
